import React, { memo, useState } from 'react';
import { CheckActiveIcon, CheckInactiveIcon } from 'v2/containers/Icons';
import './SimpleDropdownContent.scss';

export type Item = {
  key: string;
  label: string;
};

type SimpleDropdownContentProps = {
  items: Item[];
  selectedItemKey?: string;
  onSelect: (key: string) => void;
};

const SimpleDropdownContent: React.FC<SimpleDropdownContentProps> = ({
  items,
  selectedItemKey,
  onSelect,
}) => {
  return (
    <div className="simple-dropdown-content">
      {items.map(item => (
        <SimpleDropdownItem
          item={item}
          isSelected={item.key === selectedItemKey}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};

type SimpleDropdownItemProps = {
  item: Item;
  isSelected: boolean;
  onSelect: (key: string) => void;
};

const SimpleDropdownItem: React.FC<SimpleDropdownItemProps> = ({
  item,
  isSelected,
  onSelect,
}) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      key={item.key}
      className="simple-dropdown-item"
      onClick={() => onSelect(item.key)}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <p className="simple-dropdown-item-label">{item.label}</p>
      <div className="simple-dropdown-item-check-icon">
        {isSelected && CheckActiveIcon}
        {!isSelected && isHover && CheckInactiveIcon}
      </div>
    </div>
  );
};

export default memo(SimpleDropdownContent);
